import { Navigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Profile from "../admin/Profile";

export default function MyAccountPage() {
    const { user } = useAuth();
    if (user === null) return <div className="min-h-screen bg-cream-subtle" aria-label="Chargement" />;
    if (!user) return <Navigate to="/connexion" replace />;
    return (
        <main className="min-h-screen bg-cream-subtle pt-28 pb-16" data-testid="my-account-page">
            <div className="container-bc">
                <p className="text-sm mb-6">
                    <Link to="/" className="text-gold hover:underline" data-testid="my-account-back">← Retour au site</Link>
                </p>
                <Profile />
            </div>
        </main>
    );
}
